var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":_vm.href}},[_c('button',{staticClass:"btn btn-primary"},[_vm._v(" "+_vm._s(_vm.$t('general.btn.edit'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }